import React from 'react';
import { Outlet, Link } from 'react-router-dom';

const ChiefLayout = () => {
  const userDataString = localStorage.getItem((window as any).APPSETTING?.appname + 'user');
  const userData = userDataString && userDataString !== 'null' ? JSON.parse(userDataString) : null;
  const isLoggedIn = userData?.success && userData?.user?.token;

  return (
    <div className="chief-wrapper">
      <nav className="chief-nav">
        <div className="chief-nav-inner">
          <Link to="/" className="chief-nav-logo">
            <span className="logo-dot" />
            Chief of Staff
          </Link>
          <div className="chief-pub-links">
            <Link to="/login">Login</Link>
          </div>
          {isLoggedIn ? (
            <Link to="/dashboard" className="btn-gold">Dashboard →</Link>
          ) : (
            <Link to="/login" className="btn-gold">Get Started →</Link>
          )}
        </div>
      </nav>

      <div className="chief-nav-spacer" />

      <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </main>

      <footer className="chief-footer">
        © {new Date().getFullYear()} AI Chief of Staff · itpatil.com
      </footer>
    </div>
  );
};

export default ChiefLayout;
